enum SurveyStatus {
  valid = 'valid',
  scoreMissing = 'scoreMissing',
  itemsMissing = 'itemsMissing',
  scoreInvalid = 'scoreInvalid',
  surveyInvalid = 'surveyInvalid',
}

export default SurveyStatus;
